import React, { Component } from "react";
import "./navbar.css";

class Navbar extends Component {
  state = { clicked: false };
  handleclick = () => {
    this.setState({ clicked: !this.state.clicked });
  };
  render() {
    return (
      <div>
        <nav className="active">
          <a className="navbar-brand logo " href="#">
            <img src="./assets/hey.svg" />
          </a>
          <div>
            <ul
              id="navbar"
              className={this.state.clicked ? "#navbar active" : "#navbar"}
            >
              <li>
                <a href="#" className="active">
                  home
                </a>
              </li>
              <li>
                <a href="#">about</a>
              </li>
              <li>
                <a href="#">our team</a>
              </li>
              <li>
                <a href="#">Contact us</a>
              </li>
            </ul>
          </div>
          <div id="mobile" onClick={this.handleclick}>
            <i
              id="bar"
              className={
                this.state.clicked ? "fa-solid fa-times" : "fa-solid fa-bars"
              }
            ></i>
            {/* <i className="fa-solid fa-bars"></i>
          <i className="fa-solid fa-times"></i> */}
          </div>
        </nav>
      </div>
    );
  }
}
export default Navbar;
